      document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".sh-faq-slider-9503").forEach((slider) => {
      const paginationContainer = slider.parentElement.querySelector(".sh-pagination-dots");
      const slides = Array.from(slider.querySelectorAll(".sh-faq-item-9503")); // Nur sichtbare FAQ-Items
      const totalSlides = slides.length;

      // Leeren der Pagination-Dots, um Duplikate zu vermeiden
      paginationContainer.innerHTML = "";

      // Erstelle die Dots
      slides.forEach((_, index) => {
        const dot = document.createElement("span");
        if (index === 0) dot.classList.add("active"); // Der erste Punkt ist aktiv
        paginationContainer.appendChild(dot);
      });

      const dots = paginationContainer.querySelectorAll("span");
      let currentIndex = 0;

      function updateDots() {
        dots.forEach((dot, index) => {
          dot.classList.toggle("active", index === currentIndex);
        });
      }

      function updateActiveSlide() {
        let maxVisibleArea = 0;

        slides.forEach((slide, index) => {
          const slideRect = slide.getBoundingClientRect();
          const sliderRect = slider.getBoundingClientRect();

          // Berechne die sichtbare Breite des Slides
          const visibleWidth = Math.max(0, Math.min(slideRect.right, sliderRect.right) - Math.max(slideRect.left, sliderRect.left));
          if (visibleWidth > maxVisibleArea) {
            maxVisibleArea = visibleWidth;
            currentIndex = index;
          }
        });

        updateDots();
      }

      // Scroll Event Listener für Slider
      slider.addEventListener("scroll", updateActiveSlide, { passive: true }); // Passive Event für schnellere Verarbeitung
    });
  });
